import i18next from 'i18next';
import axiosInstance from 'src/utils/axios';
import logger from 'src/utils/logger';
import parse from 'src/utils/parse';
import type {
  KnowledgeBaseFolderResponse,
  KnowledgeBasePageResponse,
  KnowledgeBaseSearchResponse,
} from 'src/types/mindtime/knowledgeBase';

const baseUrl = (): string =>
  (process.env.REACT_APP_KNOWLEDGE_BASE_URL ?? '').replace(/\/$/, '');

class KnowledgeBaseApi {
  async getFolderContentsById(
    id: string = '1'
  ): Promise<KnowledgeBaseFolderResponse> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${baseUrl()}/folder/contents?id=${id}`)
        .then((response) => {
          const parsed = parse(response);
          if (parsed?.data) {
            resolve(parsed.data as KnowledgeBaseFolderResponse);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }

  async getPageById(pageId: string): Promise<KnowledgeBasePageResponse> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${baseUrl()}/pages/${pageId}`)
        .then((response) => {
          const parsed = parse(response);
          if (parsed?.data) {
            resolve(parsed.data as KnowledgeBasePageResponse);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }

  async searchPages(query: string): Promise<KnowledgeBaseSearchResponse> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${baseUrl()}/search?query=${encodeURIComponent(query)}`)
        .then((response) => {
          const parsed = parse(response);
          if (parsed?.data) {
            resolve(parsed.data as KnowledgeBaseSearchResponse);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }
}

export const knowledgeBaseApi = new KnowledgeBaseApi();
